module.exports = __webpack_public_path__ + "img/house-sm.629ffcb8.jpg";